/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import 'whatwg-fetch';
import { debounce } from "debounce";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.apiKey = self.elem.getAttribute('data-key');
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({ key: self.apiKey }).then(function (googleMaps) {
            // Call the function that initialises the rendering of the map
            self.googleMaps = googleMaps;
            // Fetch the map markers
            self.fetchMarkers();
        }).catch(function (error) {
            console.error(error)
        });
    }
    /*-------------------------------------------------*\
        FETCH MARKERS
    \*-------------------------------------------------*/
    fetchMarkers() {
        let self = this;

        // Fetch the marker data
        fetch('/api/studs.json').then(function (response) {
            return response.json();
        }).then(function (json) {
            self.distributors = json.data;
            // Render the map
            self.renderMap();
        }).catch(function (ex) {
            console.log('Parsing failed', ex);
        });
    }
    /*-------------------------------------------------*\
        RENDER MAP
    \*-------------------------------------------------*/
    renderMap() {
        let self = this;
        let infoWindow = new self.googleMaps.InfoWindow();

        // Create the map options
        let mapOptions = {
            zoom: 16,
            maxZoom: 16,
            center: new self.googleMaps.LatLng(51.1493563, -0.4530876),
            disableDefaultUI: true,
            zoomControl: true,
            styles: [{ "featureType": "landscape", "stylers": [{ "hue": "#FFBB00" }, { "saturation": 43.4 }, { "lightness": 37.6 }, { "gamma": 1 }] }, { "featureType": "road.highway", "stylers": [{ "hue": "#FFC200" }, { "saturation": -61.8 }, { "lightness": 45.6 }, { "gamma": 1 }] }, { "featureType": "road.arterial", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 51.2 }, { "gamma": 1 }] }, { "featureType": "road.local", "stylers": [{ "hue": "#FF0300" }, { "saturation": -100 }, { "lightness": 52 }, { "gamma": 1 }] }, { "featureType": "water", "stylers": [{ "hue": "#0078FF" }, { "saturation": -13.2 }, { "lightness": 2.4 }, { "gamma": 1 }] }, { "featureType": "poi", "stylers": [{ "hue": "#00FF6A" }, { "saturation": -1.1 }, { "lightness": 11.2 }, { "gamma": 1 }] }],
        };

        // Create the map
        const map = new self.googleMaps.Map(self.elem, mapOptions);

        // Create the bounds object, which will be configured later based on the marker locations
        let bounds = new self.googleMaps.LatLngBounds();

        // Loop through the distributors
        for (let i = 0; i < self.distributors.length; i++) {
            let location = self.distributors[i];
            let latLng = new self.googleMaps.LatLng(location.latitude, location.longitude);

            // Set the marker image
            let icon = '/assets/images/map-marker-flat.svg';

            // Create the marker image
            var image = {
                url: icon,
                scaledSize: new self.googleMaps.Size(15, 15),
                origin: new self.googleMaps.Point(0, 0),
                anchor: new self.googleMaps.Point(14, 16)
            };

            // Create the marker object
            let marker = new self.googleMaps.Marker({
                position: latLng,
                map: map,
                icon: image,
                title: location.title,
                animation: google.maps.Animation.DROP
            });

            // Handle marker clicks
            self.googleMaps.event.addListener(marker, "click", function (e) {
                var address = '';
                var logo = '';
                var tel = '';
                var stallions = [];
                var website = '';

                if (location.address == null) {
                    var address = '';
                } else {
                    var address = location.address;
                }

                if (location.logo == null) {
                    var logo = '';
                } else {
                    var logo = '<img alt="'+location.title+' logo" class="[ map__marker__window__content__logo ]" src="'+location.logo+'">';
                }

                if (location.tel == null) {
                    var tel = '';
                } else {
                    var tel = '<p>'+location.tel+'</p>';
                }

                if (location.stallions == null) {
                    var stallions = '';
                } else {
                    location.stallions.forEach(function(stallion) {
                        stallions.push(' '+stallion.title);
                    });
                }

                if (location.website == null) {
                    var website = '';
                } else {
                    var website = '<p class="my-1"><a href="'+location.website+'" target="_blank">Website</a></p>';
                }

                // Build the content for the infoWindow
                let infoWindowContent = `
                    <div class="[ map__marker__window ]">
                        <h2 class="[ map__marker__window__title ]">${location.title}</h2>
                        <div class="[ map__marker__window__content ]">
                            ${address}
                            ${tel}
                            <p><strong>Stallions:</strong> ${stallions}</p>
                            ${website}
                            ${logo}
                        </div>
                    </div>
                `;

                // Add the content to the infoWindow
                infoWindow.setContent(infoWindowContent);

                // Open the infoWindow
                infoWindow.open(map, marker);
            });

            // Work out the area of the map containing markers
            bounds.extend(marker.position);

            // Function to center the map with all markers visible
            let fitAndCenter = function () {
                map.setCenter(bounds.getCenter());
                map.fitBounds(bounds);
            };

            // Fit and center
            fitAndCenter();

            // Fit and center the markers on window resize
            window.onresize = debounce(fitAndCenter, 200);
        }
    }
}

export default Map;
